import React, { useRef,useEffect, useState, useCallback } from 'react';
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux"; 
import { useTranslation } from "react-i18next"; 
import { ENDPOINT } from "constants/variables";
import IconButton from '@mui/material/IconButton'; 
import DeleteIcon from '@mui/icons-material/Delete';
import MenuItem  from "@mui/material/MenuItem";
import SearchIcon from '@mui/icons-material/Search';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import "css/generalSettings.css";
import "css/customDialog.css";
import { warningErrorAction } from "actions/ErrorActions";
import { helpHttp } from "service/HelpHttp";
import ContractSearchStores from "pages/contracts/editOrNewContract/ContractSearchStores";
import ContractSearchStoresAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresAddress";
import ContractSearchStoresNimaAddresses from "pages/contracts/editOrNewContract/ContractSearchStoresNimaAddress";
import PropTypes from 'prop-types';

const initialPostalCodesToSelect = [{
    "id":0,
    "postalcode":"",
    "name":"",
    "postalcodename":"",
    "enabled":true,
    "province_id":0
}];

const initialDocumentIdToSelect = [{
    "id": 0,
    "documentid": "",
    "tradename": ""
}];

const initialNimaToSelect = [{
    "id":0,
    "nima":""
}];

const ContractCreateOrEditDestTras = ({formContract,setFormContract,setIsLoadingErrorData,errorsForm,setErrorsForm,validateFormContract,documentTypesToSelect,roadTypesToSelect,communityToSelect,expanded,optTypeToSelect}) => {
    const {t,i18n} = useTranslation(['listDataContracts']);
    const token = useSelector((state) => state.loginUser.token); 
    const roles = useSelector((state) => state.loginUser.roles);  
    const DEFAULTTYPEOFDOCUMENT = useSelector((state) => state.formatDIUser.default_documenttype); 
    const DEFAULTROADTYE = useSelector((state) => state.formatDIUser.default_roadtype); 
    const DEFAULTCOUNTRY = useSelector((state) => state.formatDIUser.default_country); 
    const DEFAULTCOUNTRY_NAME = useSelector((state) => state.formatDIUser.default_country_name); 
    const DEFAULTPROVINCE = useSelector((state) => state.formatDIUser.default_province); 
    const DEFAULTPROVINCE_NAME = useSelector((state) => state.formatDIUser.default_province_name); 
    const DEFAULTPOSTALCODE_ID = useSelector((state) => state.formatDIUser.default_postalcode); 
    const DEFAULTPOSTALCODE_CODE = useSelector((state) => state.formatDIUser.default_postalcode_code); 
    const DEFAULTPOSTALCODE_NAME = useSelector((state) => state.formatDIUser.default_postalcode_name); 
    const DEFAULTCOMMUNITY = useSelector((state) => state.formatDIUser.default_community); 
    const DEFAULTCOMMUNITY_NAME = useSelector((state) => state.formatDIUser.default_community_name); 
    const [showModalSearchStores, setShowModalSearchStores] = useState(false); 
    const [showModalSearchStoresAddress, setShowModalSearchStoresAddress] = useState(false); 
    const [showModalSearchStoresNimaAddress, setShowModalSearchStoresNimaAddress] = useState(false);          
    const dispatch = useDispatch(); 
    const [postalCodeDestTrasToSelect,setPostalCodeDestTrasToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeDestTras, setFilteredpostalCodeDestTras] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeDestTras, setHighlightedIndexPostalCodeDestTras] = useState(-1); // Índice de la opción resaltada 
    const [documentIdDestTrasToSelect,setDocumentIdDestTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredDocumentIdDestTras, setFilteredDocumentIdDestTras] = useState([]); // Opciones filtradas
    const [highlightedIndexDocumentIdDestTras, setHighlightedIndexDocumentIdDestTras] = useState(-1); // Índice de la opción resaltada 
    const [tradenameDestTrasToSelect,setTradenameDestTrasToSelect]= useState(initialDocumentIdToSelect);  
    const [filteredTradenamedDestTras, setFilteredTradenamedDestTras] = useState([]); // Opciones filtradas
    const [highlightedIndexTradenamedDestTras, setHighlightedIndexTradenamedDestTras] = useState(-1); // Índice de la opción resaltada 
    const [destTrasNimaToSelect,setDestTrasNimaToSelect]= useState(initialNimaToSelect);  
    const [filteredDestTrasNima, setFilteredDestTrasNima] = useState([]); // Opciones filtradas
    const [highlightedIndexDestTrasNima, setHighlightedIndexDestTrasNima] = useState(-1); // Índice de la opción resaltada 
     const [priority, setPriority] = useState(1);   
    const [tetxtSearch, setTetxtSearch] = useState("Ori_Tras");   
    const [postalCodeDestTrasFiscalToSelect,setPostalCodeDestTrasFiscalToSelect]= useState(initialPostalCodesToSelect);  
    const [filteredpostalCodeDestTrasFiscal, setFilteredpostalCodeDestTrasFiscal] = useState([]); // Opciones filtradas
    const [highlightedIndexPostalCodeDestTrasFiscal, setHighlightedIndexPostalCodeDestTrasFiscal] = useState(-1); // Índice de la opción resaltada 
    
    const ddRefDocIdDestTras = useRef(null);
    const ddRefTradeDestTras = useRef(null);
    const ddRefNimaDestTras = useRef(null);
    const ddRefPostalDestTras = useRef(null);

    // Debounce helper
    const useDebounce = (callback, delay = 300) => {
    const timeoutRef = useRef(null);
    return useCallback((...args) => {
        clearTimeout(timeoutRef.current);
        timeoutRef.current = setTimeout(() => {
        callback(...args);
        }, delay);
    }, [callback, delay]);
    };
    
    // Dentro del componente
    const debouncedHandleSearchPostalCode= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeDestTras([]);
            setHighlightedIndexPostalCodeDestTras(-1);
        return;
        }
        const filtered = postalCodeDestTrasToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeDestTras(filtered);
        setHighlightedIndexPostalCodeDestTras(0);
    }, 300); 

    const handleSelectPostalCodeDestTras = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            dest_tras_postalcode_id: postal.id || Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: postal.name || DEFAULTPOSTALCODE_NAME,
            dest_tras_province_id: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeDestTras([]);
        setHighlightedIndexPostalCodeDestTras(-1);
    }; 

    const handleKeyDownDPostalCodeDestTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeDestTras.length === 0 && formContract.dest_tras_postalcode_code.trim() === "") {
            setHighlightedIndexPostalCodeDestTras(postalCodeDestTrasToSelect);
            setHighlightedIndexPostalCodeDestTras(0);
        } else {
            setHighlightedIndexPostalCodeDestTras((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeDestTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefPostalDestTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeDestTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefPostalDestTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeDestTras >= 0) {
            if (highlightedIndexPostalCodeDestTras >= 0 && highlightedIndexPostalCodeDestTras < filteredpostalCodeDestTras.length) {
                handleSelectPostalCodeDestTras(filteredpostalCodeDestTras[highlightedIndexPostalCodeDestTras]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeDestTrasToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.dest_tras_postalcode_code.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                dest_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
                dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
                dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                dest_tras_province_id: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeDestTras([]);
        setHighlightedIndexPostalCodeDestTras(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchDocumentId = useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDocumentIdDestTras([]);
            setHighlightedIndexDocumentIdDestTras(-1);
            return;
        }
        const filtered = documentIdDestTrasToSelect
            .filter(store => store && store.documentid)
            .filter(store => {
            const documentid = store.documentid.toUpperCase();
            return documentid.includes(upperValue);
            })
            .slice(0, 20); // limitar resultados
        setFilteredDocumentIdDestTras(filtered);
        setHighlightedIndexDocumentIdDestTras(0);
    }, 300);
    const handleSelectDocumentIdOri = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            dest_tras_documentid: store.documentid || "",
        }));
        setFilteredDocumentIdDestTras([]);
        setHighlightedIndexDocumentIdDestTras(-1);
    }; 
    const handleKeyDownDocumentIdDestTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredDocumentIdDestTras.length === 0 && formContract.dest_tras_documentid.trim() === "") {
            setFilteredDocumentIdDestTras(documentIdDestTrasToSelect);
            setHighlightedIndexDocumentIdDestTras(0);
        } else {
            setHighlightedIndexDocumentIdDestTras((prevIndex) => {
            const nextIndex = prevIndex < filteredDocumentIdDestTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefDocIdDestTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDocumentIdDestTras((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefDocIdDestTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDocumentIdDestTras >= 0) {
        if (highlightedIndexDocumentIdDestTras >= 0 && highlightedIndexDocumentIdDestTras < filteredDocumentIdDestTras.length) {
            handleSelectDocumentIdOri(filteredDocumentIdDestTras[highlightedIndexDocumentIdDestTras]);
        }
        } else if (event.key === "Escape") {
            const isValid = documentIdDestTrasToSelect.some((store) => {
                if (!store || !store.documentid) return false; 
                const normalizedStoreId = store.documentid.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.dest_tras_documentid.toUpperCase();
                return normalizedStoreId === normalizedInputId;
            }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            dest_tras_documentid: "",
            }));
        } 
        setFilteredDocumentIdDestTras([]);
        setHighlightedIndexDocumentIdDestTras(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchTradename= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredTradenamedDestTras([]);
            setHighlightedIndexTradenamedDestTras(-1);
        return;
        }
        const filtered = tradenameDestTrasToSelect
        .filter(store => store && store.tradename)
        .filter(store => {
            const tradename = store.tradename.toUpperCase();
            return tradename.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredTradenamedDestTras(filtered);
        setHighlightedIndexTradenamedDestTras(0);
    }, 300); 

    const handleSelectTradeNameDestTras = (store) => {
        if (!store) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        dest_tras_tradename: store.tradename || "",
        dest_tras_documentid: store.documentid || formContract.dest_tras_documentid,
        
        }));
        setFilteredTradenamedDestTras([]);
        setHighlightedIndexTradenamedDestTras(-1);
    }; 

    const handleKeyDownTradenameDestTras = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredTradenamedDestTras.length === 0 && formContract.dest_tras_tradename.trim() === "") {
            setFilteredTradenamedDestTras(tradenameDestTrasToSelect);
            setHighlightedIndexTradenamedDestTras(0);
        } else {
            setHighlightedIndexTradenamedDestTras((prevIndex) => {
            const nextIndex = prevIndex < filteredTradenamedDestTras.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex,ddRefTradeDestTras);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
        setHighlightedIndexTradenamedDestTras((prevIndex) => {
            const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
            // Desplaza al elemento anterior
            scrollToElement(prevIndexValid,ddRefTradeDestTras);
            return prevIndexValid;
        });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexTradenamedDestTras >= 0) {
        if (highlightedIndexTradenamedDestTras >= 0 && highlightedIndexTradenamedDestTras < filteredTradenamedDestTras.length) {
            handleSelectTradeNameDestTras(filteredTradenamedDestTras[highlightedIndexTradenamedDestTras]);
        }
        } else if (event.key === "Escape") {
        const isValid = tradenameDestTrasToSelect.some((store) => {
            if (!store || !store.tradename) return false; 
            const normalizedTradeName = store.tradename.toUpperCase();
            const normalizedInputTradeName = formContract.dest_tras_tradename.toUpperCase();
            return normalizedTradeName === normalizedInputTradeName;
        }); 
        if (!isValid) {
            setFormContract((formContract) => ({
            ...formContract,
            dest_tras_tradename: "",
            }));
        } 
        setFilteredTradenamedDestTras([]);
        setHighlightedIndexTradenamedDestTras(-1);
        }
    }; 

    // Dentro del componente
    const debouncedHandleSearchDestTrasNima= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredDestTrasNima([]);
            setHighlightedIndexDestTrasNima(-1);
        return;
        }
        const filtered = destTrasNimaToSelect
        .filter(nt => nt && nt.nima)
        .filter(nt => {
            const nima = nt.nima.toUpperCase();
            return nima.includes(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredDestTrasNima(filtered);
        setHighlightedIndexDestTrasNima(0);
    }, 300); 
    const handleSelectDestTrasNima = (nt) => {
        if (!nt) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
        ...formContract,
        dest_tras_nima: nt.nima || ""
        }));
        setFilteredDestTrasNima([]);
        setHighlightedIndexDestTrasNima(-1);
    }; 
    const handleKeyDownDestTrasNima = (event) => {
       if (event.key === "ArrowDown") {
            if (filteredDestTrasNima.length === 0 && formContract.dest_tras_nima.trim() === "") {
                const filtered = destTrasNimaToSelect.filter(nt => nt && nt.nima).slice(0, 20);
                setFilteredDestTrasNima(filtered);
                setHighlightedIndexDestTrasNima(0);
            } else {
                setHighlightedIndexDestTrasNima((prevIndex) => {
                    const nextIndex = prevIndex < filteredDestTrasNima.length - 1 ? prevIndex + 1 : prevIndex;
                    scrollToElement(nextIndex,ddRefNimaDestTras);
                    return nextIndex;
                });
            }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexDestTrasNima((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid,ddRefNimaDestTras);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexDestTrasNima >= 0) {
            if (highlightedIndexDestTrasNima >= 0 && highlightedIndexDestTrasNima < filteredDestTrasNima.length) {
                handleSelectDestTrasNima(filteredDestTrasNima[highlightedIndexDestTrasNima]);
            }
        } else if (event.key === "Escape") {
            const isValid = destTrasNimaToSelect.some((nt) => {
                if (!nt || !nt.nima) return false; 
                const normalizedPostalCodeId = nt.nima.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.dest_tras_nima.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract, 
                dest_tras_nima: ""
            }));
        } 
        setFilteredDestTrasNima([]);
        setHighlightedIndexDestTrasNima(-1);
        }
    };

    // Dentro del componente
    const debouncedHandleSearchPostalCodeFiscal= useDebounce((searchValue) => {
        const upperValue = searchValue.toUpperCase();
        if (upperValue.trim() === "") {
            setFilteredpostalCodeDestTrasFiscal([]);
            setHighlightedIndexPostalCodeDestTrasFiscal(-1);
        return;
        }
        const filtered = postalCodeDestTrasFiscalToSelect
        .filter(postal => postal && postal.postalcode)
        .filter(postal => {
            const postalcode = postal.postalcode.toUpperCase();
            return postalcode.startsWith(upperValue);
        })
        .slice(0, 20); // limitar resultados
        setFilteredpostalCodeDestTrasFiscal(filtered);
        setHighlightedIndexPostalCodeDestTrasFiscal(0);
    }, 300); 

    const handleSelectPostalCodeDestTrasFiscal = (postal) => {
        if (!postal) return; // Validación adicional para evitar errores
        setFormContract((formContract) => ({
            ...formContract,
            dest_tras_postalcode_id_fiscal: postal.id || Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code_fiscal: postal.postalcode ||  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name_fiscal: postal.name || DEFAULTPOSTALCODE_NAME,
            dest_tras_province_id_fiscal: postal.province_id || Number(DEFAULTPROVINCE)
        }));
        setFilteredpostalCodeDestTrasFiscal([]);
        setHighlightedIndexPostalCodeDestTrasFiscal(-1);
    };
    const handleKeyDownDPostalCodeDestTrasFiscal = (event) => {
        if (event.key === "ArrowDown") {
        if (filteredpostalCodeDestTrasFiscal.length === 0 && formContract.dest_tras_postalcode_code_fiscal.trim() === "") {
            setHighlightedIndexPostalCodeDestTrasFiscal(postalCodeDestTrasFiscalToSelect);
            setHighlightedIndexPostalCodeDestTrasFiscal(0);
        } else {
            setHighlightedIndexPostalCodeDestTrasFiscal((prevIndex) => {
            const nextIndex = prevIndex < filteredpostalCodeDestTrasFiscal.length - 1 ? prevIndex + 1 : prevIndex;
            // Desplaza al siguiente elemento
            scrollToElement(nextIndex);
            return nextIndex;
            });
        }
        } else if (event.key === "ArrowUp") {
            setHighlightedIndexPostalCodeDestTrasFiscal((prevIndex) => {
                const prevIndexValid = prevIndex > 0 ? prevIndex - 1 : prevIndex;
                // Desplaza al elemento anterior
                scrollToElement(prevIndexValid);
                return prevIndexValid;
            });
        } else if ((event.key === "Enter" || event.key === "Tab") && highlightedIndexPostalCodeDestTrasFiscal >= 0) {
            if (highlightedIndexPostalCodeDestTrasFiscal >= 0 && highlightedIndexPostalCodeDestTrasFiscal < filteredpostalCodeDestTrasFiscal.length) {
                handleSelectPostalCodeDestTrasFiscal(filteredpostalCodeDestTrasFiscal[highlightedIndexPostalCodeDestTrasFiscal]);
            }
        } else if (event.key === "Escape") {
            const isValid = postalCodeDestTrasFiscalToSelect.some((postal) => {
                if (!postal || !postal.postalcode) return false; 
                const normalizedPostalCodeId = postal.postalcode.toUpperCase().replace(/[.-]/g, "");
                const normalizedInputId = formContract.dest_tras_postalcode_code_fiscal.toUpperCase();
                return normalizedPostalCodeId === normalizedInputId;
            }); 
        if (!isValid) { 
            setFormContract((formContract) => ({
                ...formContract,
                dest_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
                dest_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
                dest_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                dest_tras_province_id_fiscal: Number(DEFAULTPROVINCE)
            }));
        } 
        setFilteredpostalCodeDestTrasFiscal([]);
        setHighlightedIndexPostalCodeDestTrasFiscal(-1);
        }
    };

    // Función para desplazar el contenedor
    const scrollToElement = (index, ref) => {
        const dropdown = ref?.current;
        const item = dropdown?.children?.[index];
        if (item) item.scrollIntoView({ behavior: "smooth", block: "nearest" });
    };

    const handleBlur = useCallback((event) => {
            if (!event || !event.currentTarget) return;
        // Asegúrate de que no se cierra si haces clic en un elemento de la lista
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setFilteredpostalCodeDestTras([]);
            setHighlightedIndexPostalCodeDestTras(-1);
            setFilteredDocumentIdDestTras([]);
            setHighlightedIndexDocumentIdDestTras(-1);
            setFilteredTradenamedDestTras([]);
            setHighlightedIndexTradenamedDestTras(-1);  
            setFilteredDestTrasNima([]);
            setHighlightedIndexDestTrasNima(-1); 
             setFilteredpostalCodeDestTrasFiscal([]);
            setHighlightedIndexPostalCodeDestTrasFiscal(-1);
        }
    }, []);

    const handleChangeSelectDocumentType_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            dest_tras_documnettype_id:event.target.value
        }));
    };

    const handleBlurSelectDocumentType_Dest_tras = (e) => {
        handleChangeSelectDocumentType_Dest_tras(e);
    };
    
    const handleChangeSelectRoadType_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            dest_tras_roadtype_id : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Dest_tras = (e) => {
        handleChangeSelectRoadType_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeSelectCommunity_Dest_tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            dest_tras_community_id : event.target.value   
        }));
    };
    const handleBlurSelectCommunity_Dest_tras = (e) => {
        handleChangeSelectCommunity_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };

    const handleChangeDataEditContract_Dest_tras = (e) => {
        const { name, value } = e.target;
        setFormContract(formContract => ({
          ...formContract,
          [name]: value,
        }));
    };

    const handleBlurDataEditContract_Dest_tras = (e) => {
        handleChangeDataEditContract_Dest_tras(e);
        setErrorsForm(validateFormContract());
    };
    
    const searchFormStore = (event) => {
        setShowModalSearchStores(true);
    };

    const searchFormStoreAddress = (event) => {
        setPriority(4);
        setTetxtSearch("Dest_Tras");
        setShowModalSearchStoresAddress(true);
    };

     const searchFormStoreAddressFiscal = (event) => {
        setPriority(-1);
        setTetxtSearch("Dest_Tras_Fiscal")
        setShowModalSearchStoresAddress(true);
    };

    const searchFormStoreNimaAddress = (event) => {
        setPriority(4);
        setTetxtSearch("Dest_Tras");
        setShowModalSearchStoresNimaAddress(true);
    };

    const handleChangeSelectRoadTypeFiscal_Dest_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            dest_tras_roadtype_id_fiscal : event.target.value 
        }));
    };

    const handleBlurSelectRoadType_Fiscal_Dest_Tras = (e) => {
        handleChangeSelectRoadTypeFiscal_Dest_Tras(e);
        setErrorsForm(validateFormContract());
    };

     const handleChangeSelectCommunityFiscal_Dest_Tras = (event) => {
        setFormContract(formContract => ({
            ...formContract,
            dest_tras_community_id_fiscal : event.target.value   
        }));
    };

    const handleBlurSelectCommunityFiscal_Dest_Tras = (e) => {
        handleChangeSelectCommunityFiscal_Dest_Tras(e);
        setErrorsForm(validateFormContract());
    };

    const deleteDateDestTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            dest_tras_store_id:0,
            dest_tras_documnettype_id: Number(DEFAULTTYPEOFDOCUMENT),
            dest_tras_documentid:"",
            dest_tras_tradename: "",
            dest_tras_name: "",
            dest_tras_contactname: "",
            dest_tras_nima: "",
            dest_tras_inscription: "",
            dest_tras_grnp:"",
            dest_tras_opt: 0,
            dest_tras_phone: "",
            dest_tras_email: "",
            dest_tras_roadtype_id: Number(DEFAULTROADTYE),
            dest_tras_street: "",
            dest_tras_country_id: Number(DEFAULTCOUNTRY),
            dest_tras_country_name:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id: Number(DEFAULTPROVINCE),
            dest_tras_province_name:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name: DEFAULTCOMMUNITY_NAME,
            dest_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            dest_tras_street_fiscal: "",
            dest_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            dest_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            dest_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME 
        }));
        setErrorsForm(validateFormContract());
        setErrorsForm(errorsForm => ({
            ...errorsForm,
            dest_tras_store_id:"",
            dest_tras_documnettype_id:"",
            dest_tras_documentid:"",
            dest_tras_tradename: "",
            dest_tras_name: "",
            dest_tras_contactname: "",
            dest_tras_nima: "",
            dest_tras_inscription: "",
            dest_tras_grnp:"",
            dest_tras_opt: "",
            dest_tras_phone: "",
            dest_tras_email: "",
            dest_tras_roadtype_id: "",
            dest_tras_street: "",
            dest_tras_country_id: "",
            dest_tras_country_name: "",
            dest_tras_province_id: "",
            dest_tras_province_name: "",
            dest_tras_postalcode_id: "",
            dest_tras_postalcode_code: "",
            dest_tras_postalcode_name: "",
            dest_tras_community_id: "",
            dest_tras_community_name: "",
            dest_tras_roadtype_id_fiscal: "",
            dest_tras_street_fiscal: "",
            dest_tras_country_id_fiscal: "",
            dest_tras_country_name_fiscal: "",
            dest_tras_province_id_fiscal: "",
            dest_tras_province_name_fiscal: "",
            dest_tras_postalcode_id_fiscal: "",
            dest_tras_postalcode_code_fiscal: "",
            dest_tras_postalcode_name_fiscal: "",
            dest_tras_community_id_fiscal: "",
            dest_tras_community_name_fiscal: "",
        }));
    };

    const deleteDataSteetDestTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            dest_tras_roadtype_id: Number(DEFAULTROADTYE),
            dest_tras_street: "",
            dest_tras_country_id: Number(DEFAULTCOUNTRY),
            dest_tras_country_name:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id: Number(DEFAULTPROVINCE),
            dest_tras_province_name:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id:  Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name: DEFAULTCOMMUNITY_NAME, 
            dest_tras_nima: "",
            dest_tras_inscription: "",
            dest_tras_grnp:"",
            dest_tras_opt: 0
        }));
        setErrorsForm(validateFormContract());
    };

    const deleteDataStreetFiscalDestTras = (event) => {
        setFormContract(formContract => ({
          ...formContract,
            dest_tras_roadtype_id_fiscal: Number(DEFAULTROADTYE),
            dest_tras_country_id_fiscal: Number(DEFAULTCOUNTRY),
            dest_tras_street_fiscal: "",
            dest_tras_country_name_fiscal:DEFAULTCOUNTRY_NAME,
            dest_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
            dest_tras_province_name_fiscal:DEFAULTPROVINCE_NAME,
            dest_tras_postalcode_id_fiscal:  Number(DEFAULTPOSTALCODE_ID),
            dest_tras_postalcode_code_fiscal:  DEFAULTPOSTALCODE_CODE,
            dest_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
            dest_tras_community_id_fiscal: Number(DEFAULTCOMMUNITY),
            dest_tras_community_name_fiscal: DEFAULTCOMMUNITY_NAME
        }));
        setErrorsForm(validateFormContract());
    };

    useEffect(() => {
        let isMounted = true;
        const fetchExistNumberDocument = async () => {
            try {
              const getData = await helpHttp().get2(ENDPOINT,`contract/getexiststorebynumberdocument/`,token,formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim());
              if (getData.err) {
                dispatch(warningErrorAction(t('Text_InvalidCredentials')));
              } else if (isMounted) {
                if (getData>0 && getData!==formContract.dest_tras_store_id){
                    fetchStoreNumberDocument();
                }
              }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
  
        const fetchStoreNumberDocument = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getcontractstorebynumberdocument/`,token,formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, ""));
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    if (getData!==undefined && getData!==null && getData!==""){
                        setFormContract(formContract => ({
                            ...formContract,
                            dest_tras_store_id: getData.store_id,
                            dest_tras_documnettype_id: (getData.documnettype_id===undefined 
                                                    || getData.documnettype_id===null  
                                                    || getData.documnettype_id===""
                                                    || getData.documnettype_id==="0"
                                                    || getData.documnettype_id===0)?
                                                    Number(DEFAULTTYPEOFDOCUMENT):getData.documnettype_id,
                            dest_tras_tradename: getData.tradename,
                            dest_tras_name: getData.name,
                            dest_tras_contactname: getData.contacperson,
                            dest_tras_nima: getData.nima_dest_tras,
                            dest_tras_inscription: getData.pygr_dest_tras,
                            dest_tras_grnp:getData.grnp_dest_tras,
                            dest_tras_opt: getData.opt_dest_tras,
                            dest_tras_phone: getData.phone,
                            dest_tras_email: getData.email, 
                            dest_tras_roadtype_id: (getData.roadtype_id===undefined 
                                                    || getData.roadtype_id===null  
                                                    || getData.roadtype_id===""
                                                    || getData.roadtype_id==="0"
                                                    || getData.roadtype_id===0)?
                                                    Number(DEFAULTROADTYE):getData.roadtype_id,
                            dest_tras_street: getData.street,  
                            dest_tras_country_id: (getData.country_id===undefined 
                                                    || getData.country_id===null  
                                                    || getData.country_id===""
                                                    || getData.country_id==="0"
                                                    || getData.country_id===0)?
                                                    Number(DEFAULTCOUNTRY):getData.country_id,
                            dest_tras_country_name: (getData.country_name===undefined 
                                                    || getData.country_name===null  
                                                    || getData.country_name==="" )?
                                                    DEFAULTCOUNTRY_NAME:getData.country_name,
                            dest_tras_province_id: (getData.province_id===undefined 
                                                    || getData.province_id===null  
                                                    || getData.province_id===""
                                                    || getData.province_id==="0"
                                                    || getData.province_id===0)?
                                                    Number(DEFAULTPROVINCE):getData.province_id,
                            dest_tras_province_name: (getData.province_name===undefined 
                                                    || getData.province_name===null  
                                                    || getData.province_name==="" )?
                                                    DEFAULTPROVINCE_NAME:getData.province_name, 
                            dest_tras_postalcode_id: (getData.postalcode_id===undefined 
                                                        || getData.postalcode_id===null  
                                                        || getData.postalcode_id===""
                                                        || getData.postalcode_id==="0"
                                                        || getData.postalcode_id===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id,
                            dest_tras_postalcode_code: (getData.postalcode_code===undefined 
                                                        || getData.postalcode_code===null  
                                                        || getData.postalcode_code==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code,
                            dest_tras_postalcode_name:   (getData.postalcode_name===undefined 
                                                        || getData.postalcode_name===null  
                                                        || getData.postalcode_name==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name,                       
                            dest_tras_community_id: (getData.community_id===undefined 
                                                        || getData.community_id===null  
                                                        || getData.community_id===""
                                                        || getData.community_id==="0"
                                                        || getData.community_id===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id,
                            dest_tras_community_name:   (getData.community_name===undefined 
                                                        || getData.community_name===null  
                                                        || getData.community_name==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name,
                            dest_tras_roadtype_id_fiscal: (getData.roadtype_id_fiscal===undefined 
                                                        || getData.roadtype_id_fiscal===null  
                                                        || getData.roadtype_id_fiscal===""
                                                        || getData.roadtype_id_fiscal==="0"
                                                        || getData.roadtype_id_fiscal===0)?
                                                        Number(DEFAULTROADTYE):getData.roadtype_id_fiscal,
                            dest_tras_street_fiscal: getData.street_fiscal,
                            dest_tras_country_id_fiscal: (getData.country_id_fiscal===undefined 
                                                        || getData.country_id_fiscal===null  
                                                        || getData.country_id_fiscal===""
                                                        || getData.country_id_fiscal==="0"
                                                        || getData.country_id_fiscal===0)?
                                                        Number(DEFAULTCOUNTRY):getData.country_id_fiscal,
                            dest_tras_country_name_fiscal: (getData.country_name_fiscal===undefined 
                                                        || getData.country_name_fiscal===null  
                                                        || getData.country_name_fiscal==="" )?
                                                        DEFAULTCOUNTRY_NAME:getData.country_name_fiscal,
                            dest_tras_province_id_fiscal: (getData.province_id_fiscal===undefined 
                                                        || getData.province_id_fiscal===null  
                                                        || getData.province_id_fiscal===""
                                                        || getData.province_id_fiscal==="0"
                                                        || getData.province_id_fiscal===0)?
                                                        Number(DEFAULTPROVINCE):getData.province_id_fiscal,
                            dest_tras_province_name_fiscal: (getData.province_name_fiscal===undefined 
                                                        || getData.province_name_fiscal===null  
                                                        || getData.province_name_fiscal==="" )?
                                                        DEFAULTPROVINCE_NAME:getData.province_name_fiscal, 
                            dest_tras_postalcode_id_fiscal: (getData.postalcode_id_fiscal===undefined 
                                                        || getData.postalcode_id_fiscal===null  
                                                        || getData.postalcode_id_fiscal===""
                                                        || getData.postalcode_id_fiscal==="0"
                                                        || getData.postalcode_id_fiscal===0)?
                                                        Number(DEFAULTPOSTALCODE_ID):getData.postalcode_id_fiscal,
                            dest_tras_postalcode_code_fiscal: (getData.postalcode_code_fiscal===undefined 
                                                        || getData.postalcode_code_fiscal===null  
                                                        || getData.postalcode_code_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_CODE:getData.postalcode_code_fiscal,
                            dest_tras_postalcode_name_fiscal:   (getData.postalcode_name_fiscal===undefined 
                                                        || getData.postalcode_name_fiscal===null  
                                                        || getData.postalcode_name_fiscal==="" )?
                                                         DEFAULTPOSTALCODE_NAME:getData.postalcode_name_fiscal,                       
                            dest_tras_community_id_fiscal: (getData.community_id_fiscal===undefined 
                                                        || getData.community_id_fiscal===null  
                                                        || getData.community_id_fiscal===""
                                                        || getData.community_id_fiscal==="0"
                                                        || getData.community_id_fiscal===0)?
                                                        Number(DEFAULTCOMMUNITY):getData.community_id_fiscal,
                            dest_tras_community_name_fiscal:   (getData.community_name_fiscal===undefined 
                                                        || getData.community_name_fiscal===null  
                                                        || getData.community_name_fiscal==="" )?
                                                         DEFAULTCOMMUNITY_NAME:getData.community_name_fiscal
                        }));
                        setErrorsForm(validateFormContract());
                    }  
                }         
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_documentid && formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!==""){
                fetchExistNumberDocument();
            } 
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,expanded,formContract.dest_tras_documentid,errorsForm.dest_tras_documentid,setIsLoadingErrorData,DEFAULTCOMMUNITY,DEFAULTCOUNTRY,setFormContract,formContract.dest_tras_store_id,DEFAULTPROVINCE,setErrorsForm,validateFormContract,
        DEFAULTCOMMUNITY_NAME,DEFAULTCOUNTRY_NAME,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPOSTALCODE_NAME,DEFAULTPROVINCE_NAME,DEFAULTROADTYE,DEFAULTTYPEOFDOCUMENT
    ]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataDocumentIdDestTras = async () => {
          try {
            const getData = await helpHttp().get2(ENDPOINT,`contract/getlistdocumentidcontracts/`,token,
              (formContract.dest_tras_documentid!==undefined && formContract.dest_tras_documentid!==null && formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim():"-1"); 
            if (getData.err) {
              dispatch(warningErrorAction(t('Text_InvalidCredentials')));
            } else if (isMounted) {
              setDocumentIdDestTrasToSelect(getData); 
            }
          } catch (error) {
            dispatch(warningErrorAction(t('Text_IncorrectData'))); 
          }
        };   
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_documentid && formContract.dest_tras_documentid.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataDocumentIdDestTras();
            }
        } else{
            setDocumentIdDestTrasToSelect(initialDocumentIdToSelect);
        } 
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.dest_tras_documentid,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataTradenameDestTras = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlisttradenamecontracts/`,token,
                    (formContract.dest_tras_tradename!==undefined && formContract.dest_tras_tradename!==null && formContract.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setTradenameDestTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData'))); 
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_tradename && formContract.dest_tras_tradename.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataTradenameDestTras();
            }
        } else{
            setTradenameDestTrasToSelect(initialDocumentIdToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.dest_tras_tradename,expanded]);
    
    useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeDestTras = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.dest_tras_postalcode_code!==undefined && formContract.dest_tras_postalcode_code!==null && formContract.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeDestTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_postalcode_code && formContract.dest_tras_postalcode_code.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeDestTras();
            } 
        } else{
            setPostalCodeDestTrasToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.dest_tras_postalcode_code,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);
    
     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeDestTrasFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.dest_tras_postalcode_code_fiscal!==undefined && formContract.dest_tras_postalcode_code_fiscal!==null && formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeDestTrasToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_postalcode_code_fiscal && formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeDestTrasFiscal();
            } 
        } else{
            setPostalCodeDestTrasToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.dest_tras_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

     useEffect(() => {
        let isMounted = true; 
        const fetchDataPostalCodeDestFiscal = async () => {
            try {
                const getData = await helpHttp().get2(ENDPOINT,`contract/getlistpostalcodect/`,token,
                    (formContract.dest_tras_postalcode_code_fiscal!==undefined && formContract.dest_tras_postalcode_code_fiscal!==null && formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setPostalCodeDestTrasFiscalToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel2'){
            if (formContract.dest_tras_postalcode_code_fiscal && formContract.dest_tras_postalcode_code_fiscal.replace(/[.\-/\\|]/g, "").trim()!=="") { 
                fetchDataPostalCodeDestFiscal();
            } 
        } else{
            setPostalCodeDestTrasFiscalToSelect(initialPostalCodesToSelect);
        }  
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract.dest_tras_postalcode_code_fiscal,expanded,DEFAULTPROVINCE,DEFAULTPOSTALCODE_CODE,DEFAULTPOSTALCODE_ID,DEFAULTPROVINCE_NAME,setFormContract]);

     useEffect(() => {
        let isMounted = true; 
        const fetchDataNimaDestTras = async () => {
            try {
                const getData = await helpHttp().get5(ENDPOINT,`searchct/getlistnimas`,token,formContract.dest_tras_store_id, 
                    (formContract.dest_tras_nima!==undefined && formContract.dest_tras_nima!==null && formContract.dest_tras_nima.replace(/[.\-/\\|]/g, "").trim()!=="")?formContract.dest_tras_nima.replace(/[.\-/\\|]/g, "").trim():"-1"); 
                if (getData.err) {
                    dispatch(warningErrorAction(t('Text_InvalidCredentials')));
                } else if (isMounted) {
                    setDestTrasNimaToSelect(getData);
                }
            } catch (error) {
                dispatch(warningErrorAction(t('Text_IncorrectData')));  
            }
        };  
        if (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4'){
            if (formContract.dest_tras_store_id && formContract.dest_tras_store_id!==null && formContract.dest_tras_store_id!=="" && formContract.dest_tras_store_id!=="0" && formContract.dest_tras_store_id!==0){
                fetchDataNimaDestTras(); 
            }else{
                setDestTrasNimaToSelect(initialNimaToSelect);
            }
        }
        return () => { isMounted = false };
    }, [t,token,dispatch,i18n,roles,formContract,expanded,setFormContract,formContract.dest_tras_store_id]);
        
    return(
    (expanded!==undefined && expanded!==null && expanded!==false && expanded==='panel4') &&
        <>
            <div className="row p-2"> 
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_DocuentType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="dest_tras_documnettype_id"
                        name="dest_tras_documnettype_id"
                        value={ (formContract.dest_tras_documnettype_id === undefined || formContract.dest_tras_documnettype_id ===null || formContract.dest_tras_documnettype_id ===""
                            || formContract.dest_tras_documnettype_id ==="0" || formContract.dest_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT):formContract.dest_tras_documnettype_id}
                        inputProps={{ style: {width: 200,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectDocumentType_Dest_tras}
                        onChange={handleChangeSelectDocumentType_Dest_tras}
                        helperText={errorsForm.dest_tras_documnettype_id!=null && errorsForm.dest_tras_documnettype_id!==""?t(errorsForm.dest_tras_documnettype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_documnettype_id === undefined || formContract.dest_tras_documnettype_id ===null || formContract.dest_tras_documnettype_id ===""
                                || formContract.dest_tras_documnettype_id ==="0" || formContract.dest_tras_documnettype_id ===0)?Number(DEFAULTTYPEOFDOCUMENT): formContract.dest_tras_documnettype_id
                        }}>
                        <option key={0} value=""/>
                        {documentTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {option.name}
                            </option>
                        ))}
                    </TextField>  
                    {i18n.language==="es"?<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>:<>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</>}
                    <label className="text-primary" style={{ fontSize: 18}}>{t('Text_CONTRACT_CIF')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="dest_tras_documentid"
                            name="dest_tras_documentid"
                            value={formContract.dest_tras_documentid}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                dest_tras_documentid: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDocumentId(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDocumentIdDestTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.dest_tras_documentid!=null?t(errorsForm.dest_tras_documentid):t('PlaceHolder_CONTRACT_CIF')}
                            placeholder={t('PlaceHolder_CONTRACT_CIF')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?283:323,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDocumentIdDestTras.length > 0 && (
                            <div
                                ref={ddRefDocIdDestTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "400px",
                                overflowY: "auto",
                                width: "250%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDocumentIdDestTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectDocumentIdOri(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDocumentIdDestTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDocumentIdDestTras ? "white" : "black",
                                    }}
                                >
                                    {store.documentid} - {store.tradename}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>   
                    &nbsp;&nbsp;
                     <IconButton  size="small" className="deletesmall-select-button"   onClick={deleteDateDestTras}>
                        <DeleteIcon style={{fontSize: 28}}/>
                    </IconButton>
                    &nbsp;&nbsp;
                    {roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores'))&&
                        <IconButton  size="small" className="edit-select-button" onClick={searchFormStore}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }  
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_TRADENAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="dest_tras_tradename"
                            name="dest_tras_tradename"
                            value={formContract.dest_tras_tradename}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                    ...prev,
                                    dest_tras_tradename: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchTradename(e.target.value);
                            }}
                            onKeyDown={handleKeyDownTradenameDestTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.dest_tras_tradename!=null && errorsForm.dest_tras_tradename!==""?t(errorsForm.dest_tras_tradename):t('PlaceHolder_CONTRACT_TRADENAME')}
                            placeholder={t('PlaceHolder_CONTRACT_TRADENAME')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?858:834,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredTradenamedDestTras.length > 0 && (
                            <div
                                ref={ddRefTradeDestTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                maxWidth: "800px",
                                overflowY: "auto",
                                width: "150%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredTradenamedDestTras.map((store, index) => (
                                <MenuItem
                                    key={store.id}
                                    onClick={() => handleSelectTradeNameDestTras(store)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexTradenamedDestTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexTradenamedDestTras ? "white" : "black",
                                    }}
                                >
                                    {store.tradename} - {store.documentid}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NAME')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_name" 
                        name="dest_tras_name"
                        value={formContract.dest_tras_name}
                        inputProps={{ style: {width: i18n.language==='es'?812:857,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_name!=null && errorsForm.dest_tras_name!==""?t(errorsForm.dest_tras_name):t('PlaceHolder_CONTRACT_NAME')}
                        placeholder={t('PlaceHolder_CONTRACT_NAME')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                </div>
                <div className="form-group"> 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_CONTACT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_contactname" 
                        name="dest_tras_contactname"
                        value={formContract.dest_tras_contactname}
                        inputProps={{ style: {width: i18n.language==='es'?795:840,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_contactname!=null && errorsForm.dest_tras_contactname!==""?t(errorsForm.dest_tras_contactname):t('PlaceHolder_CONTRACT_CONTACT')}
                        placeholder={t('PlaceHolder_CONTRACT_CONTACT')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                </div>
            </div> 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_roadtype"
                        name="dest_tras_roadtype"
                        value={ (formContract.dest_tras_roadtype_id === undefined || formContract.dest_tras_roadtype_id ===null || formContract.dest_tras_roadtype_id ===""
                            || formContract.dest_tras_roadtype_id ==="0" || formContract.dest_tras_roadtype_id ===0)?Number(DEFAULTROADTYE):formContract.dest_tras_roadtype_id}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Dest_tras}
                        onChange={handleChangeSelectRoadType_Dest_tras}
                        helperText={errorsForm.dest_tras_roadtype_id!=null && errorsForm.dest_tras_roadtype_id!==""?t(errorsForm.dest_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_roadtype_id === undefined || formContract.dest_tras_roadtype_id ===null || formContract.dest_tras_roadtype_id ===""
                                || formContract.dest_tras_roadtype_id ==="0" || formContract.dest_tras_roadtype_id ===0)?Number(DEFAULTROADTYE): formContract.dest_tras_roadtype_id
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_street" 
                        name="dest_tras_street"
                        value={formContract.dest_tras_street}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_street!=null && errorsForm.dest_tras_street!==""?t(errorsForm.dest_tras_street):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataSteetDestTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton> 
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.dest_tras_documentid!==undefined && formContract.dest_tras_documentid!=="") ?
                    <IconButton  size="small" className={`edit-${
                        (formContract.dest_tras_store_id===undefined
                        || formContract.dest_tras_store_id===""
                        || formContract.dest_tras_store_id==="0"
                        || formContract.dest_tras_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.dest_tras_store_id===undefined
                        || formContract.dest_tras_store_id===""
                        || formContract.dest_tras_store_id==="0"
                        || formContract.dest_tras_store_id===0 }
                                onClick={searchFormStoreAddress}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>  
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="dest_tras_postalcode_code"
                            name="dest_tras_postalcode_code"
                            value={formContract.dest_tras_postalcode_code}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    dest_tras_postalcode_code: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCode(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeDestTras}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.dest_tras_postalcode_code.trim().toUpperCase();
                                    const matchedPostal = postalCodeDestTrasToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            dest_tras_postalcode_id: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            dest_tras_postalcode_code: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            dest_tras_postalcode_name: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            dest_tras_province_id: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            dest_tras_postalcode_id: Number(DEFAULTPOSTALCODE_ID),
                                            dest_tras_postalcode_code: DEFAULTPOSTALCODE_CODE,
                                            dest_tras_postalcode_name: DEFAULTPOSTALCODE_NAME,
                                            dest_tras_province_id: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeDestTras([]);
                                    setHighlightedIndexPostalCodeDestTras(-1);
                                }
                            }}
                            label={errorsForm.dest_tras_postalcode_code!=null && errorsForm.dest_tras_postalcode_code!==""?t(errorsForm.dest_tras_postalcode_code):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeDestTras.length > 0 && (
                            <div
                                ref={ddRefPostalDestTras}
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeDestTras.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeDestTras(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeDestTras ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeDestTras ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_postalcode_name" 
                        name="dest_tras_postalcode_name"
                        value={formContract.dest_tras_postalcode_name}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_postalcode_name!=null && errorsForm.dest_tras_postalcode_name!==""?t(errorsForm.dest_tras_contactname):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_community_id"
                        name="dest_tras_community_id"
                        value={ (formContract.dest_tras_community_id === undefined || formContract.dest_tras_community_id ===null || formContract.dest_tras_community_id ===""
                            || formContract.dest_tras_community_id ==="0" || formContract.dest_tras_community_id ===0)?Number(DEFAULTCOMMUNITY):formContract.dest_tras_community_id}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunity_Dest_tras}
                        onChange={handleChangeSelectCommunity_Dest_tras}
                        helperText={errorsForm.dest_tras_community_id!=null  && errorsForm.dest_tras_community_id!==""?t(errorsForm.dest_tras_community_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_community_id === undefined || formContract.dest_tras_community_id ===null || formContract.dest_tras_community_id ===""
                                || formContract.dest_tras_community_id ==="0" || formContract.dest_tras_community_id ===0)?Number(DEFAULTCOMMUNITY): formContract.dest_tras_community_id
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div> 
            <Typography style={{color:"#067330", fontSize: 16}} >  
                {t('Text_CONTRACT_ADDRESS_FISCAL')}
            </Typography>
            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_RoadType')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_roadtype_id_fiscal"
                        name="dest_tras_roadtype_id_fiscal"
                        value={ (formContract.dest_tras_roadtype_id_fiscal === undefined || formContract.dest_tras_roadtype_id_fiscal ===null || formContract.dest_tras_roadtype_id_fiscal ===""
                            || formContract.dest_tras_roadtype_id_fiscal ==="0" || formContract.dest_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE):formContract.dest_tras_roadtype_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?150:150,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectRoadType_Fiscal_Dest_Tras}
                        onChange={handleChangeSelectRoadTypeFiscal_Dest_Tras}
                        helperText={errorsForm.dest_tras_roadtype_id_fiscal!=null && errorsForm.dest_tras_roadtype_id_fiscal!==""?t(errorsForm.dest_tras_roadtype_id):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_roadtype_id_fiscal === undefined || formContract.dest_tras_roadtype_id_fiscal ===null || formContract.dest_tras_roadtype_id_fiscal ===""
                                || formContract.dest_tras_roadtype_id_fiscal ==="0" || formContract.dest_tras_roadtype_id_fiscal ===0)?Number(DEFAULTROADTYE): formContract.dest_tras_roadtype_id_fiscal
                        }}>
                        <option key={0} value=""/>
                        {roadTypesToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_ADDRESS')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_street_fiscal" 
                        name="dest_tras_street_fiscal"
                        value={formContract.dest_tras_street_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?449:462,  fontSize: '18px', }, maxLength: 250 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_street_fiscal!=null && errorsForm.dest_tras_street_fiscal!==""?t(errorsForm.dest_tras_street_fiscal):t('PlaceHolder_CONTRACT_ADDRESS')}
                        placeholder={t('PlaceHolder_CONTRACT_ADDRESS')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                </div>
                &nbsp;&nbsp;
                <IconButton  size="small" className="deletesmall-select-button" onClick={deleteDataStreetFiscalDestTras}>
                    <DeleteIcon style={{fontSize: 28}}/>
                </IconButton> 
                &nbsp;&nbsp;
                {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.dest_tras_documentid!==undefined && formContract.dest_tras_documentid!=="") ?
                <IconButton  size="small" className={`edit-${
                        (formContract.dest_tras_store_id===undefined
                        || formContract.dest_tras_store_id===""
                        || formContract.dest_tras_store_id==="0"
                        || formContract.dest_tras_store_id===0 )
                        ? "noselect-button": "select-button" }`}
                        disabled={formContract.dest_tras_store_id===undefined
                        || formContract.dest_tras_store_id===""
                        || formContract.dest_tras_store_id==="0"
                        || formContract.dest_tras_store_id===0 }
                                onClick={searchFormStoreAddressFiscal}>
                    <SearchIcon style={{fontSize: 28}}/>
                    </IconButton>:
                    <IconButton  size="small" className="edit-noselect-button" disabled>
                        <SearchIcon style={{fontSize: 28}}/>
                    </IconButton> 
                }
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_PostalCode')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="dest_tras_postalcode_code_fiscal"
                            name="dest_tras_postalcode_code_fiscal"
                            value={formContract.dest_tras_postalcode_code_fiscal}
                            onChange={(e) => {
                                    setFormContract(prev => ({
                                    ...prev,
                                    dest_tras_postalcode_code_fiscal: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchPostalCodeFiscal(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDPostalCodeDestTrasFiscal}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                    const inputPostalCode = formContract.dest_tras_postalcode_code_fiscal.trim().toUpperCase();
                                    const matchedPostal = postalCodeDestTrasFiscalToSelect.find((postal) => {
                                    const normalizedPostal = postal.postalcode?.toUpperCase() || "";
                                    return normalizedPostal === inputPostalCode;
                                    });

                                    if (matchedPostal) {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            dest_tras_postalcode_id_fiscal: matchedPostal.id || Number(DEFAULTPOSTALCODE_ID),
                                            dest_tras_postalcode_code_fiscal: matchedPostal.postalcode || DEFAULTPOSTALCODE_CODE,
                                            dest_tras_postalcode_name_fiscal: matchedPostal.name || DEFAULTPOSTALCODE_NAME,
                                            dest_tras_province_id_fiscal: matchedPostal.province_id || Number(DEFAULTPROVINCE),
                                        }));
                                    } else {
                                        setFormContract((prev) => ({
                                            ...prev,
                                            dest_tras_postalcode_id_fiscal: Number(DEFAULTPOSTALCODE_ID),
                                            dest_tras_postalcode_code_fiscal: DEFAULTPOSTALCODE_CODE,
                                            dest_tras_postalcode_name_fiscal: DEFAULTPOSTALCODE_NAME,
                                            dest_tras_province_id_fiscal: Number(DEFAULTPROVINCE),
                                        }));
                                    }
                                    setFilteredpostalCodeDestTrasFiscal([]);
                                    setHighlightedIndexPostalCodeDestTrasFiscal(-1);
                                }
                            }}
                            label={errorsForm.dest_tras_postalcode_code_fiscal!=null && errorsForm.dest_tras_postalcode_code_fiscal!==""?t(errorsForm.dest_tras_postalcode_code_fiscal):t('Text_CONTRACT_PostalCode')}
                            placeholder={t('Text_CONTRACT_PostalCode')}
                            variant="standard"
                            inputProps={{ style: {width: i18n.language==='es'?100:100,  fontSize: '18px', }, maxLength: 100 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}} 
                        />  
                        {/* Desplegable dinámico */}
                        {filteredpostalCodeDestTrasFiscal.length > 0 && (
                            <div
                                className="dropdown-class"
                                style={{
                                position: "absolute",
                                left:'0px',
                                border: "2px solid #4e73df", // Borde azul (#4e73df)
                                borderRadius: "4px",
                                marginTop: "4px",
                                maxHeight: "200px",
                                overflowY: "auto",
                                width: "350%",
                                fontSize: '18px',
                                backgroundColor: "#f8f9fa", // Fondo gris claro
                                zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredpostalCodeDestTrasFiscal.map((postal, index) => (
                                <MenuItem
                                    key={postal.id}
                                    onClick={() => handleSelectPostalCodeDestTrasFiscal(postal)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexPostalCodeDestTrasFiscal ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexPostalCodeDestTrasFiscal ? "white" : "black",
                                    }}
                                >
                                    {postal.postalcode} - {postal.name}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Locality')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_postalcode_name_fiscal" 
                        name="dest_tras_postalcode_name_fiscal"
                        value={formContract.dest_tras_postalcode_name_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?210:241,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_postalcode_name_fiscal!=null && errorsForm.dest_tras_postalcode_name_fiscal!==""?t(errorsForm.dest_tras_postalcode_name_fiscal):t('Text_CONTRACT_Locality')}
                        placeholder={t('Text_CONTRACT_Locality')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                        disabled
                    />  
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Community')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_community_id_fiscal"
                        name="dest_tras_community_id_fiscal"
                        value={ (formContract.dest_tras_community_id_fiscal === undefined || formContract.dest_tras_community_id_fiscal ===null || formContract.dest_tras_community_id_fiscal ===""
                            || formContract.dest_tras_community_id_fiscal ==="0" || formContract.dest_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY):formContract.dest_tras_community_id_fiscal}
                        inputProps={{ style: {width: i18n.language==='es'?200:200,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        variant="outlined"
                        onBlur={handleBlurSelectCommunityFiscal_Dest_Tras}
                        onChange={handleChangeSelectCommunityFiscal_Dest_Tras}
                        helperText={errorsForm.dest_tras_community_id_fiscal!=null  && errorsForm.dest_tras_community_id_fiscal!==""?t(errorsForm.dest_tras_community_id_fiscal):""}
                        select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_community_id_fiscal === undefined || formContract.dest_tras_community_id_fiscal ===null || formContract.dest_tras_community_id_fiscal ===""
                                || formContract.dest_tras_community_id_fiscal ==="0" || formContract.dest_tras_community_id_fiscal ===0)?Number(DEFAULTCOMMUNITY): formContract.dest_tras_community_id_fiscal
                        }}>
                        {communityToSelect.map((option) => (
                            <option key={option.id} value={option.id}>
                                {i18n.language==="es"?option.namees:option.nameen}
                            </option>
                        ))}
                    </TextField>
                </div>
            </div>

            <hr className="sidebar-divider d-none d-md-block"/>
            <div className="row p-2"> 
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Phone')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp; 
                    <TextField
                        id="dest_tras_phone" 
                        name="dest_tras_phone"
                        value={formContract.dest_tras_phone}
                        inputProps={{ style: {width: 180,  fontSize: '18px', }, maxLength: 30 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}    
                        label={errorsForm.dest_tras_phone!=null && errorsForm.dest_tras_phone!==""?t(errorsForm.dest_tras_phone):t('PlaceHolder_CONTRACT_Phone')}
                        placeholder={t('PlaceHolder_CONTRACT_Phone')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_Email')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="dest_tras_email" 
                        name="dest_tras_email"
                        value={formContract.dest_tras_email}
                        inputProps={{ style: {width: i18n.language==='es'?319:335 ,  fontSize: '18px'}, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        label={errorsForm.dest_tras_email!=null && errorsForm.dest_tras_email!==""?t(errorsForm.dest_tras_email):t('PlaceHolder_CONTRACT_Email')}
                        placeholder={t('PlaceHolder_CONTRACT_Email')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_NIMA')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <span style={{ position: "relative" }}>
                        <TextField
                            id="dest_tras_nima"
                            name="dest_tras_nima"
                            value={formContract.dest_tras_nima}
                            onChange={(e) => {
                                setFormContract(prev => ({
                                ...prev,
                                dest_tras_nima: e.target.value.toUpperCase()
                                }));
                                debouncedHandleSearchDestTrasNima(e.target.value);
                            }}
                            onKeyDown={handleKeyDownDestTrasNima}
                            onBlur={(event) => {
                                if (!event.relatedTarget || !event.relatedTarget.closest(".dropdown-class")) {
                                handleBlur();
                                }
                            }}
                            label={errorsForm.dest_tras_nima!=null && errorsForm.dest_tras_nima!==""?t(errorsForm.dest_tras_nima):t('PlaceHolder_CONTRACT_NIMA')}
                            placeholder={t('PlaceHolder_CONTRACT_NIMA')}
                            variant="standard"
                            inputProps={{ style: {width: 133,  fontSize: '18px'}, maxLength: 50 }}
                            InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        />  
                        {/* Desplegable dinámico */}
                        {filteredDestTrasNima.length > 0 && (
                            <div
                                ref={ddRefNimaDestTras}
                                className="dropdown-class"
                                style={{
                                    position: "absolute",
                                    left:'0px',
                                    border: "2px solid #4e73df", // Borde azul (#4e73df)
                                    borderRadius: "4px",
                                    marginTop: "4px",
                                    maxHeight: "200px",
                                    maxWidth: "750px",
                                    overflowY: "auto",
                                    width: "100%",
                                    fontSize: '18px',
                                    backgroundColor: "#f8f9fa", // Fondo gris claro
                                    zIndex: 1000,
                                }}
                                onMouseDown={(e) => e.preventDefault()} // Evita que se cierre al hacer clic en la barra de scroll
                            >
                                {filteredDestTrasNima.map((nt, index) => (
                                <MenuItem
                                    key={nt.id}
                                    onClick={() => handleSelectDestTrasNima(nt)}
                                    style={{
                                        cursor: "pointer",
                                        padding: "8px",
                                        borderBottom: "1px solid #eee",
                                        fontSize: '18px',
                                        backgroundColor:
                                        index === highlightedIndexDestTrasNima ? "#4e73df" : "transparent",
                                        color: index === highlightedIndexDestTrasNima ? "white" : "black",
                                    }}
                                >
                                    {nt.nima}
                                </MenuItem>
                                ))}
                            </div>
                        )}
                    </span>
                    &nbsp;&nbsp;
                    {(roles[0].listmenus.find((key)=>(key.name==='SubMenu_Form_View_Stores')) && formContract.dest_tras_documentid!==undefined && formContract.dest_tras_documentid!=="") ?
                         <IconButton  size="small" className={`edit-${
                            (formContract.dest_tras_store_id===undefined
                            || formContract.dest_tras_store_id===""
                            || formContract.dest_tras_store_id==="0"
                            || formContract.dest_tras_store_id===0
                            )? "noselect-button": "select-button" }`}
                            disabled={formContract.dest_tras_store_id===undefined
                            || formContract.dest_tras_store_id===""
                            || formContract.dest_tras_store_id==="0"
                            || formContract.dest_tras_store_id===0} 
                            onClick={searchFormStoreNimaAddress}>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton>:
                        <IconButton  size="small" className="edit-noselect-button" disabled>
                            <SearchIcon style={{fontSize: 28}}/>
                        </IconButton> 
                    }
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_INSCRIPTION')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="dest_tras_inscription" 
                        name="dest_tras_inscription"
                        value={formContract.dest_tras_inscription}
                        inputProps={{ style: {width:350,  fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}      
                        label={errorsForm.dest_tras_inscription!=null && errorsForm.dest_tras_inscription!==""?t(errorsForm.dest_tras_inscription):t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        placeholder={t('PlaceHolder_CONTRACT_INSCRIPTION')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; 
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_OPT')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;  
                    <TextField
                        id="dest_tras_opt"
                        name="dest_tras_opt"
                        value={ (formContract.dest_tras_opt === undefined || formContract.dest_tras_opt ===null || formContract.dest_tras_opt ===""
                            || formContract.dest_tras_opt ==="0" || formContract.dest_tras_opt ===0)?0:formContract.dest_tras_opt}
                        inputProps={{ style: {width: i18n.language==='es'?194:171,  fontSize: '18px', }, maxLength: 100 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}     
                        variant="outlined"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                        helperText={errorsForm.dest_tras_opt!=null?t(errorsForm.dest_tras_opt):""}
                            select
                        SelectProps={{
                            native: true,
                            value: (formContract.dest_tras_opt === undefined || formContract.dest_tras_opt ===null || formContract.dest_tras_opt ===""
                                || formContract.dest_tras_opt ==="0" || formContract.dest_tras_opt ===0)?0: formContract.dest_tras_opt
                        }}>
                        <option key={0} value=""/>
                        {optTypeToSelect.map((option) => (
                        <option key={option.id} value={option.id}>
                            {option.code} - {option.namees.substring(0,20)}
                        </option>
                        ))}
                    </TextField>            
                </div>
                <div className="form-group">
                    <label className="text-primary" style={{ fontSize: 18 }}>{t('Text_CONTRACT_GESTOR')} :</label>
                    &nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="dest_tras_grnp" 
                        name="dest_tras_grnp"
                        value={formContract.dest_tras_grnp}
                        inputProps={{ style: {width: i18n.language==='es'?684:250, fontSize: '18px'}, maxLength: 50 }}
                        InputLabelProps={{ style: {fontSize: '18px', background: '#FFFFFF'}}}
                        label={errorsForm.dest_tras_grnp!=null && errorsForm.dest_tras_grnp!==""?t(errorsForm.dest_tras_grnp):t('PlaceHolder_CONTRACT_GESTOR')}
                        placeholder={t('PlaceHolder_CONTRACT_GESTOR')}
                        variant="standard"
                        onBlur={handleBlurDataEditContract_Dest_tras}
                        onChange={handleChangeDataEditContract_Dest_tras} 
                    />
                    
                </div>
            </div>  
            <ContractSearchStores
                showModalSearchStores={showModalSearchStores}
                setShowModalSearchStores={setShowModalSearchStores}
                selectStores={"Dest_Tras"}
                setFormContract={setFormContract}
            />
            <ContractSearchStoresAddresses
                showModalSearchStoresAddress={showModalSearchStoresAddress}
                setShowModalSearchStoresAddress={setShowModalSearchStoresAddress}
               selectStores={tetxtSearch}
                setFormContract={setFormContract}
                titleTable={formContract.dest_tras_tradename}
                store_id={formContract.dest_tras_store_id}
                priority={priority}
            />
            <ContractSearchStoresNimaAddresses
                showModalSearchStoresNimaAddress={showModalSearchStoresNimaAddress}
                setShowModalSearchStoresNimaAddress={setShowModalSearchStoresNimaAddress}
                selectStores={"Dest_Tras"}
                setFormContract={setFormContract}
                titleTable={formContract.dest_tras_tradename}
                store_id={formContract.dest_tras_store_id} 
            />


        </> 
    )
}

ContractCreateOrEditDestTras.propTypes = {
    formContract: PropTypes.object.isRequired,
    setFormContract: PropTypes.func.isRequired,
    setIsLoadingErrorData: PropTypes.func.isRequired,
    errorsForm: PropTypes.object.isRequired,
    setErrorsForm: PropTypes.func.isRequired,
    validateFormContract: PropTypes.func.isRequired,
    documentTypesToSelect: PropTypes.array.isRequired,
    roadTypesToSelect: PropTypes.array.isRequired,
    communityToSelect: PropTypes.array.isRequired,
    optTypeToSelect: PropTypes.array.isRequired
  };
  
  export default ContractCreateOrEditDestTras;

